import { CredentialsDto } from "./dto";
import { Credentials } from "./models";

export function mapCredentialsFromDto(dto: CredentialsDto): Credentials {
  return {
    token: {
      key: dto.token.key,
      accessExpiresAt: new Date(dto.token.access_expires_at),
      refreshExpiresAt: new Date(dto.token.refresh_expires_at),
    },
    profile: {
      id: dto.user.id,
      firstName: dto.user.first_name,
      lastName: dto.user.last_name,
      email: dto.user.email,
    },
  };
}
